import { useState } from 'react';

import config from '@/config';
import { useNavbarIconUrl } from '@shared/lib/hooks';

import styles from './authentication.module.css';

import { AuthenticationDialog, ModeType } from './authentication-dialog';
import { useT } from '@shared/i18n';

export const AuthenticationView = ({ onSuccess }: AuthenticationViewProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const [mode, setMode] = useState<ModeType>('login');

	const onCloseDialog = () => {
		setIsOpen(false);
	};
	const onClickSignIn = () => {
		setIsOpen(true);
		setMode('login');
	};
	const onClickSignUp = () => {
		if (config?.app?.auth?.type === 'cognito') {
			return;
		}
		const registerUrl = config.build?.links?.register;
		if (registerUrl) {
			open(registerUrl, '_blank');
		}

		// setIsOpen(false);
		/*if (config.build.title === 'Yummy') {
			open('https://club.yummy.men/', '_blank');
		}
		open('https://www.pw.org/user/register', '_blank');*/
		// setIsOpen(false);
		// setMode('signup');
	};
	const classNames = [styles['view']];
	if (isOpen) {
		classNames.push(styles['dialog-open']);
	}
	return (
		<div className={classNames.join(' ')}>
			<Wrapper
				onClickSignIn={onClickSignIn}
				onClickSignUp={onClickSignUp}
			/>

			<AuthenticationDialog
				mode={mode}
				setMode={setMode}
				onClickSignUp={onClickSignUp}
				onClickLogIn={onClickSignIn}
				onCloseDialog={onCloseDialog}
				isOpen={isOpen}
				onSuccess={onSuccess}
			/>
		</div>
	);
};

interface AuthenticationViewProps {
	onSuccess: () => void;
}

const Wrapper = ({ onClickSignIn, onClickSignUp }: WrapperProps) => {
	const t = useT();
	// Same light/dark pick as the home topbar's logo, so the login screen
	// doesn't show the light-mode logo on a dark background.
	const navbarIconUrl = useNavbarIconUrl();
	let registerBtn = null;
	if (config?.build?.links?.register) {
		registerBtn = <button onClick={onClickSignUp}>{t('auth.register')}</button>;
	}

	return (
		<div className={styles['wrapper']}>
			<div>
				<h2>{t('auth.welcome')}</h2>
				<img
					className={styles['logo']}
					alt={t('common.logo')}
					src={navbarIconUrl}
				/>
				<button onClick={onClickSignIn}>{t('common.signIn')}</button>
				{registerBtn}
				{config?.build?.links?.forgotPassword ? (
					<small>
						<a
							rel="noreferrer"
							href={config?.build?.links?.forgotPassword}
							target="_blank"
						>
							{t('auth.forgotPassword')}
						</a>
					</small>
				) : null}
			</div>
		</div>
	);
};

interface WrapperProps {
	onClickSignIn: () => void;
	onClickSignUp: () => void;
}
